var installedModules = {};
var moduleToHandlerMapping = {
	43324: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(98807), __webpack_require__.e(37580)]).then(() => (() => (__webpack_require__(37580))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	13063: {
		getter: () => (Promise.all([__webpack_require__.e(59452), __webpack_require__.e(17141), __webpack_require__.e(31340)]).then(() => (() => (__webpack_require__(31340))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	63478: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(13063), __webpack_require__.e(98807), __webpack_require__.e(34615), __webpack_require__.e(95072)]).then(() => (() => (__webpack_require__(95072))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	90714: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(81208), __webpack_require__.e(13063), __webpack_require__.e(97586), __webpack_require__.e(31292), __webpack_require__.e(46356), __webpack_require__.e(60302), __webpack_require__.e(51965), __webpack_require__.e(32714), __webpack_require__.e(56551), __webpack_require__.e(63786), __webpack_require__.e(68687), __webpack_require__.e(70287), __webpack_require__.e(54730), __webpack_require__.e(22314), __webpack_require__.e(8186), __webpack_require__.e(73344), __webpack_require__.e(29253), __webpack_require__.e(92381), __webpack_require__.e(33264)]).then(() => (() => (__webpack_require__(33264))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-ui-components",
	},
	25338: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(13063), __webpack_require__.e(98807), __webpack_require__.e(46443)]).then(() => (() => (__webpack_require__(46443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	78832: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(13063), __webpack_require__.e(97586), __webpack_require__.e(46356), __webpack_require__.e(98807), __webpack_require__.e(25338), __webpack_require__.e(97451), __webpack_require__.e(81383), __webpack_require__.e(69724)]).then(() => (() => (__webpack_require__(10793))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.14.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/core",
	},
	76005: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(25338), __webpack_require__.e(71667), __webpack_require__.e(44569), __webpack_require__.e(2812), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(17021))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-data-access-api",
	},
	51965: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(81208), __webpack_require__.e(13063), __webpack_require__.e(97586), __webpack_require__.e(87670), __webpack_require__.e(31292), __webpack_require__.e(46356), __webpack_require__.e(63478), __webpack_require__.e(97472), __webpack_require__.e(98807), __webpack_require__.e(33358), __webpack_require__.e(25338), __webpack_require__.e(78832), __webpack_require__.e(60302), __webpack_require__.e(93106), __webpack_require__.e(32714), __webpack_require__.e(63786), __webpack_require__.e(34615), __webpack_require__.e(68687), __webpack_require__.e(72486), __webpack_require__.e(84368), __webpack_require__.e(29068), __webpack_require__.e(97451), __webpack_require__.e(82090), __webpack_require__.e(54730), __webpack_require__.e(22314), __webpack_require__.e(12530), __webpack_require__.e(59452), __webpack_require__.e(86525), __webpack_require__.e(85431), __webpack_require__.e(81642), __webpack_require__.e(8186), __webpack_require__.e(37650), __webpack_require__.e(61207), __webpack_require__.e(84760)]).then(() => (() => (__webpack_require__(84760))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.12.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/components",
	},
	26277: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(97586), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(38909))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-util-translate",
	},
	71667: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(36167))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-util-environment",
	},
	34615: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(25338), __webpack_require__.e(80436)]).then(() => (() => (__webpack_require__(80436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	70287: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(63478), __webpack_require__.e(78832), __webpack_require__.e(651), __webpack_require__.e(21460)]).then(() => (() => (__webpack_require__(21460))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/payments-util-models",
	},
	62336: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(13063), __webpack_require__.e(46356), __webpack_require__.e(63478), __webpack_require__.e(98807), __webpack_require__.e(25338), __webpack_require__.e(78832), __webpack_require__.e(97451), __webpack_require__.e(81383), __webpack_require__.e(91315)]).then(() => (() => (__webpack_require__(91315))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.14.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/core/auth/crosscutting",
	},
	68895: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(71667), __webpack_require__.e(14309), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(95266))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/portal-util-interceptors",
	},
	92381: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(81208), __webpack_require__.e(97586), __webpack_require__.e(87670), __webpack_require__.e(25338), __webpack_require__.e(78832), __webpack_require__.e(60302), __webpack_require__.e(72486), __webpack_require__.e(73059)]).then(() => (() => (__webpack_require__(73059))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12.11.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/payment-methods-widget",
	},
	40684: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(81208), __webpack_require__.e(97586), __webpack_require__.e(87670), __webpack_require__.e(25338), __webpack_require__.e(78832), __webpack_require__.e(60302), __webpack_require__.e(84368), __webpack_require__.e(37650), __webpack_require__.e(31144)]).then(() => (() => (__webpack_require__(31144))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.6.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/comparador-widget",
	},
	77543: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(46356), __webpack_require__.e(25338), __webpack_require__.e(71667), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(8774))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-data-access-config",
	},
	32743: {
		getter: () => (Promise.all([__webpack_require__.e(29393), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(17677))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-data-access-interceptors",
	},
	89590: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(6970))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser/animations/async",
	},
	93447: {
		getter: () => (Promise.all([__webpack_require__.e(29393), __webpack_require__.e(651), __webpack_require__.e(14309), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(26159))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/portal-data-access",
	},
	97472: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(47172)]).then(() => (() => (__webpack_require__(47172))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	7234: {
		getter: () => (__webpack_require__.e(60316).then(() => (() => (__webpack_require__(60316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	98807: {
		getter: () => (Promise.all([__webpack_require__.e(59452), __webpack_require__.e(17141), __webpack_require__.e(23620)]).then(() => (() => (__webpack_require__(23620))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	55458: {
		getter: () => (__webpack_require__.e(85689).then(() => (() => (__webpack_require__(85689))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/signals",
	},
	77500: {
		getter: () => (__webpack_require__.e(56745).then(() => (() => (__webpack_require__(56745))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/primitives/event-dispatch",
	},
	6921: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(61803))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.1.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/signals",
	},
	56551: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(13063), __webpack_require__.e(31292), __webpack_require__.e(98807), __webpack_require__.e(34615), __webpack_require__.e(74385)]).then(() => (() => (__webpack_require__(74385))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.3.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngx-formly/core",
	},
	31292: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(98807), __webpack_require__.e(34456)]).then(() => (() => (__webpack_require__(34456))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	97940: {
		getter: () => (__webpack_require__.e(73453).then(() => (() => (__webpack_require__(73453))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@reduxjs/toolkit",
	},
	83255: {
		getter: () => (Promise.all([__webpack_require__.e(29393), __webpack_require__.e(76005), __webpack_require__.e(48471), __webpack_require__.e(6921), __webpack_require__.e(28431), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(9852))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/modifications-data-access",
	},
	36591: {
		getter: () => (__webpack_require__.e(95479).then(() => (() => (__webpack_require__(95479))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/academic-variation-util-models",
	},
	97586: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(98807), __webpack_require__.e(90852)]).then(() => (() => (__webpack_require__(90852))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~15.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngx-translate/core",
	},
	87670: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(81208), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(33358), __webpack_require__.e(87438), __webpack_require__.e(49136)]).then(() => (() => (__webpack_require__(49136))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/button",
	},
	46356: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(98807), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(49074))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	48471: {
		getter: () => (Promise.all([__webpack_require__.e(29393), __webpack_require__.e(76005), __webpack_require__.e(62336), __webpack_require__.e(72076), __webpack_require__.e(87725)]).then(() => (() => (__webpack_require__(32903))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-data-access-facade",
	},
	73344: {
		getter: () => (Promise.all([__webpack_require__.e(81208), __webpack_require__.e(13063), __webpack_require__.e(87670), __webpack_require__.e(31292), __webpack_require__.e(98807), __webpack_require__.e(25338), __webpack_require__.e(78832), __webpack_require__.e(6921), __webpack_require__.e(60302), __webpack_require__.e(51965), __webpack_require__.e(93106), __webpack_require__.e(63786), __webpack_require__.e(72486), __webpack_require__.e(82090), __webpack_require__.e(54730), __webpack_require__.e(85431), __webpack_require__.e(3036)]).then(() => (() => (__webpack_require__(3036))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.19.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/subject-picker",
	},
	5047: {
		getter: () => (Promise.all([__webpack_require__.e(76005), __webpack_require__.e(83255), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(60311))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/academic-variation-data-access",
	},
	88304: {
		getter: () => (Promise.all([__webpack_require__.e(90714), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(65277))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/academic-variation-ui",
	},
	81208: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(13063), __webpack_require__.e(17780)]).then(() => (() => (__webpack_require__(17780))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/api",
	},
	60302: {
		getter: () => (Promise.all([__webpack_require__.e(81208), __webpack_require__.e(13063), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(97472), __webpack_require__.e(15176), __webpack_require__.e(4456), __webpack_require__.e(25211), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(91564))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/messages",
	},
	84368: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(81208), __webpack_require__.e(45340), __webpack_require__.e(97472), __webpack_require__.e(20252), __webpack_require__.e(14733), __webpack_require__.e(45206)]).then(() => (() => (__webpack_require__(45206))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/accordion",
	},
	37650: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(51486))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/card",
	},
	61288: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(31292), __webpack_require__.e(97472), __webpack_require__.e(15176), __webpack_require__.e(32714), __webpack_require__.e(63786), __webpack_require__.e(34615), __webpack_require__.e(64266), __webpack_require__.e(87438), __webpack_require__.e(22314), __webpack_require__.e(12530), __webpack_require__.e(86525), __webpack_require__.e(88432), __webpack_require__.e(76676)]).then(() => (() => (__webpack_require__(76676))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/table",
	},
	33358: {
		getter: () => (Promise.all([__webpack_require__.e(45340), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(17159))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/autofocus",
	},
	93106: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(81208), __webpack_require__.e(45340), __webpack_require__.e(80405)]).then(() => (() => (__webpack_require__(80405))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/tooltip",
	},
	32714: {
		getter: () => (Promise.all([__webpack_require__.e(81208), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(48361))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/inputtext",
	},
	63786: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(81208), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(33358), __webpack_require__.e(15176), __webpack_require__.e(93106), __webpack_require__.e(14733), __webpack_require__.e(64266), __webpack_require__.e(17928), __webpack_require__.e(97656), __webpack_require__.e(26895)]).then(() => (() => (__webpack_require__(26895))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/dropdown",
	},
	68687: {
		getter: () => (__webpack_require__.e(8528).then(() => (() => (__webpack_require__(8528))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^29.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ng-icons/phosphor-icons/regular",
	},
	72486: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(81208), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(97472), __webpack_require__.e(16280)]).then(() => (() => (__webpack_require__(16280))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/dialog",
	},
	29068: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(38233)]).then(() => (() => (__webpack_require__(38233))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^29.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ng-icons/core",
	},
	82090: {
		getter: () => (Promise.all([__webpack_require__.e(81208), __webpack_require__.e(33358), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(54665))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/radiobutton",
	},
	54730: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(33358), __webpack_require__.e(15176), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(26771))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/checkbox",
	},
	22314: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(87670), __webpack_require__.e(86116), __webpack_require__.e(97472), __webpack_require__.e(33358), __webpack_require__.e(20252), __webpack_require__.e(14733), __webpack_require__.e(35088), __webpack_require__.e(41314)]).then(() => (() => (__webpack_require__(41314))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/calendar",
	},
	12530: {
		getter: () => (Promise.all([__webpack_require__.e(45340), __webpack_require__.e(87670), __webpack_require__.e(86116), __webpack_require__.e(33358), __webpack_require__.e(32714), __webpack_require__.e(73046), __webpack_require__.e(61759)]).then(() => (() => (__webpack_require__(61759))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/inputnumber",
	},
	17978: {
		getter: () => (Promise.all([__webpack_require__.e(99398), __webpack_require__.e(93860), __webpack_require__.e(43157)]).then(() => (() => (__webpack_require__(43157))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/paginator",
	},
	23366: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(99398), __webpack_require__.e(33358), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(69656))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/selectbutton",
	},
	48986: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(33358), __webpack_require__.e(15176), __webpack_require__.e(14733), __webpack_require__.e(64266), __webpack_require__.e(4456), __webpack_require__.e(17928), __webpack_require__.e(97656), __webpack_require__.e(66664), __webpack_require__.e(92159)]).then(() => (() => (__webpack_require__(92159))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/multiselect",
	},
	66664: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(99398), __webpack_require__.e(97472), __webpack_require__.e(88432), __webpack_require__.e(66664), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(55222))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/panel",
	},
	81642: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(97472), __webpack_require__.e(15176), __webpack_require__.e(4456), __webpack_require__.e(25211), __webpack_require__.e(61225)]).then(() => (() => (__webpack_require__(61225))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/toast",
	},
	8186: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(86116), __webpack_require__.e(97472), __webpack_require__.e(33358), __webpack_require__.e(96371)]).then(() => (() => (__webpack_require__(96371))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/password",
	},
	61207: {
		getter: () => (__webpack_require__.e(45391).then(() => (() => (__webpack_require__(45391))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^29.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ng-icons/phosphor-icons/fill",
	},
	15488: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(93616))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/tag",
	},
	27288: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(87058))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/inputtextarea",
	},
	27946: {
		getter: () => (Promise.all([__webpack_require__.e(45340), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(96997))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/steps",
	},
	28578: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(14733), __webpack_require__.e(64266), __webpack_require__.e(4456), __webpack_require__.e(87438), __webpack_require__.e(17928), __webpack_require__.e(38784)]).then(() => (() => (__webpack_require__(38784))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/autocomplete",
	},
	30836: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(20252), __webpack_require__.e(35088), __webpack_require__.e(634)]).then(() => (() => (__webpack_require__(634))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/tabview",
	},
	38396: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(46764))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/inputswitch",
	},
	41678: {
		getter: () => (Promise.all([__webpack_require__.e(45340), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(89735))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/keyfilter",
	},
	45280: {
		getter: () => (Promise.all([__webpack_require__.e(45340), __webpack_require__.e(86116), __webpack_require__.e(32084)]).then(() => (() => (__webpack_require__(32084))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/inputmask",
	},
	55046: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(46095))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/avatar",
	},
	56100: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(21416))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/progressbar",
	},
	57880: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(15176), __webpack_require__.e(68160)]).then(() => (() => (__webpack_require__(68160))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/confirmdialog",
	},
	61660: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(20252), __webpack_require__.e(35088), __webpack_require__.e(94132)]).then(() => (() => (__webpack_require__(94132))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/tabmenu",
	},
	64730: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(36171))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/divider",
	},
	66800: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(97196)]).then(() => (() => (__webpack_require__(97196))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/sidebar",
	},
	78520: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(93860), __webpack_require__.e(73046), __webpack_require__.e(15728)]).then(() => (() => (__webpack_require__(15728))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/menubar",
	},
	80530: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(6068))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/knob",
	},
	81958: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(86116), __webpack_require__.e(34198)]).then(() => (() => (__webpack_require__(34198))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/overlaypanel",
	},
	84826: {
		getter: () => (Promise.all([__webpack_require__.e(20252), __webpack_require__.e(65475)]).then(() => (() => (__webpack_require__(65475))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/breadcrumb",
	},
	86718: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(66831)]).then(() => (() => (__webpack_require__(66831))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/scrollpanel",
	},
	91690: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(45340), __webpack_require__.e(99398), __webpack_require__.e(23673)]).then(() => (() => (__webpack_require__(23673))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/menu",
	},
	58045: {
		getter: () => (__webpack_require__.e(20076).then(() => (() => (__webpack_require__(20076))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/discounts-util-models",
	},
	651: {
		getter: () => (__webpack_require__.e(14758).then(() => (() => (__webpack_require__(14758))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-util-types",
	},
	82221: {
		getter: () => (Promise.all([__webpack_require__.e(76005), __webpack_require__.e(83255), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(84795))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/discounts-data-access",
	},
	97220: {
		getter: () => (Promise.all([__webpack_require__.e(90714), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(20983))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/discounts-ui",
	},
	29393: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(6921), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(98791))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-data-access-state",
	},
	99181: {
		getter: () => (__webpack_require__.e(4390).then(() => (() => (__webpack_require__(4390))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/documentation-util-models",
	},
	56607: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(8873))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-util-file-download",
	},
	64869: {
		getter: () => (Promise.all([__webpack_require__.e(29393), __webpack_require__.e(76005), __webpack_require__.e(48471), __webpack_require__.e(6921), __webpack_require__.e(68895), __webpack_require__.e(99181), __webpack_require__.e(56607), __webpack_require__.e(72076), __webpack_require__.e(10106)]).then(() => (() => (__webpack_require__(94796))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/documentation-data-access",
	},
	26336: {
		getter: () => (Promise.all([__webpack_require__.e(81208), __webpack_require__.e(13063), __webpack_require__.e(46356), __webpack_require__.e(90714), __webpack_require__.e(56551), __webpack_require__.e(68687), __webpack_require__.e(84368), __webpack_require__.e(29068), __webpack_require__.e(99181), __webpack_require__.e(96633)]).then(() => (() => (__webpack_require__(96633))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/documentation-ui",
	},
	28431: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(13484))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/modifications-util-models",
	},
	99274: {
		getter: () => (Promise.all([__webpack_require__.e(56551), __webpack_require__.e(29253), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(20368))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/modifications-ui",
	},
	29253: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(12606))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-util-form",
	},
	42863: {
		getter: () => (Promise.all([__webpack_require__.e(76005), __webpack_require__.e(6921), __webpack_require__.e(70287), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(47278))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/payments-data-access",
	},
	16316: {
		getter: () => (Promise.all([__webpack_require__.e(31292), __webpack_require__.e(32714), __webpack_require__.e(56551), __webpack_require__.e(63786), __webpack_require__.e(84368), __webpack_require__.e(40684), __webpack_require__.e(78068)]).then(() => (() => (__webpack_require__(78068))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/payments-ui",
	},
	99235: {
		getter: () => (__webpack_require__.e(50021).then(() => (() => (__webpack_require__(50021))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^29.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ng-icons/phosphor-icons/bold",
	},
	67819: {
		getter: () => (__webpack_require__.e(54209).then(() => (() => (__webpack_require__(54209))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/personal-data-util-models",
	},
	57035: {
		getter: () => (Promise.all([__webpack_require__.e(29393), __webpack_require__.e(76005), __webpack_require__.e(6921), __webpack_require__.e(68895), __webpack_require__.e(67819), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(70681))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/personal-data-data-access",
	},
	48894: {
		getter: () => (Promise.all([__webpack_require__.e(90714), __webpack_require__.e(67819), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(12012))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/personal-data-ui",
	},
	14309: {
		getter: () => (__webpack_require__.e(42564).then(() => (() => (__webpack_require__(42564))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-util-models",
	},
	44569: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(46356), __webpack_require__.e(63478), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(57656))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-data-access-router",
	},
	51463: {
		getter: () => (Promise.all([__webpack_require__.e(29393), __webpack_require__.e(76005), __webpack_require__.e(6921), __webpack_require__.e(26399), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(23671))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/studies-data-access",
	},
	49384: {
		getter: () => (Promise.all([__webpack_require__.e(68687), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(42183))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/portal-ui",
	},
	2812: {
		getter: () => (Promise.all([__webpack_require__.e(16026), __webpack_require__.e(78057)]).then(() => (() => (__webpack_require__(78057))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~18.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ngrx-rtk-query",
	},
	34594: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(62799))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-ui-components/input-gdpr",
	},
	60277: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(62515))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.3.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngx-formly/core/preset",
	},
	68520: {
		getter: () => (Promise.all([__webpack_require__.e(82090), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(87347))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-ui-components/input-radio-group",
	},
	78632: {
		getter: () => (Promise.all([__webpack_require__.e(81642), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(95922))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/shared-ui-components/error-toast",
	},
	85486: {
		getter: () => (Promise.all([__webpack_require__.e(63478), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(61740))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/floatlabel",
	},
	87421: {
		getter: () => (__webpack_require__.e(22198).then(() => (() => (__webpack_require__(22198))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.4.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "tailwind-merge",
	},
	26399: {
		getter: () => (Promise.all([__webpack_require__.e(651), __webpack_require__.e(72899)]).then(() => (() => (__webpack_require__(72899))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/studies-util-models",
	},
	59658: {
		getter: () => (Promise.all([__webpack_require__.e(26399), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(21243))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/studies-ui",
	},
	11335: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(74909))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.1.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/signals/entities",
	},
	30079: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(8275))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.1.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngrx/signals/rxjs-interop",
	},
	1949: {
		getter: () => (Promise.all([__webpack_require__.e(12448), __webpack_require__.e(17592)]).then(() => (() => (__webpack_require__(17592))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@reduxjs/toolkit/query",
	},
	16026: {
		getter: () => (Promise.all([__webpack_require__.e(43324), __webpack_require__.e(1949), __webpack_require__.e(22123)]).then(() => (() => (__webpack_require__(22123))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~18.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ngrx-rtk-query/core",
	},
	4442: {
		getter: () => (Promise.all([__webpack_require__.e(43324), __webpack_require__.e(13063), __webpack_require__.e(46356), __webpack_require__.e(98807), __webpack_require__.e(81383), __webpack_require__.e(1949), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(13749))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~18.0.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ngrx-rtk-query/store",
	},
	10982: {
		getter: () => (__webpack_require__.e(7251).then(() => (() => (__webpack_require__(7251))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/utils",
	},
	45340: {
		getter: () => (__webpack_require__.e(35228).then(() => (() => (__webpack_require__(35228))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/dom",
	},
	20252: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(45994))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/chevronright",
	},
	37114: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(85804))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/chevrondown",
	},
	99398: {
		getter: () => (Promise.all([__webpack_require__.e(45340), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(30078))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/ripple",
	},
	86116: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(57727))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/times",
	},
	64266: {
		getter: () => (Promise.all([__webpack_require__.e(87438), __webpack_require__.e(22222)]).then(() => (() => (__webpack_require__(22222))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/scroller",
	},
	4456: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(20839))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/timescircle",
	},
	87438: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(4766))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/spinner",
	},
	17928: {
		getter: () => (Promise.all([__webpack_require__.e(97472), __webpack_require__.e(33576)]).then(() => (() => (__webpack_require__(33576))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/overlay",
	},
	89056: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(61582))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/home",
	},
	35088: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(44959))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/chevronleft",
	},
	7880: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(24837))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/calendar",
	},
	23524: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(37223))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/chevronup",
	},
	15176: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(82289))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/check",
	},
	54452: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(69551))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/windowminimize",
	},
	62760: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(31717))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/windowmaximize",
	},
	64362: {
		getter: () => (__webpack_require__.e(72076).then(() => (() => (__webpack_require__(61257))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/focustrap",
	},
	97656: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(73647))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/search",
	},
	1188: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(97243))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/blank",
	},
	40378: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(19436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/baseicon",
	},
	73046: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(98776))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angledown",
	},
	92552: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(31147))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angleup",
	},
	93860: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(61726))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angleright",
	},
	50440: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(15961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/bars",
	},
	23618: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(13814))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/exclamationtriangle",
	},
	8860: {
		getter: () => (Promise.all([__webpack_require__.e(10982), __webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(48075))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/infocircle",
	},
	44283: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(77965))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/minus",
	},
	58444: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(10203))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angleleft",
	},
	78702: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(78540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angledoubleleft",
	},
	93844: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(14607))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/angledoubleright",
	},
	88432: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(41155))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/plus",
	},
	58162: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(40210))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/eye",
	},
	72600: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(23217))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/eyeslash",
	},
	16888: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(25809))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/arrowup",
	},
	18186: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(25306))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/arrowdown",
	},
	31840: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(71293))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/sortamountupalt",
	},
	44680: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(53529))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/filter",
	},
	54808: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(24299))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/trash",
	},
	63628: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(19407))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/sortamountdown",
	},
	67054: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(12032))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/filterslash",
	},
	69274: {
		getter: () => (Promise.all([__webpack_require__.e(86116), __webpack_require__.e(33358), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(88833))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/tristatecheckbox",
	},
	79442: {
		getter: () => (Promise.all([__webpack_require__.e(40378), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(63868))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^17.18.15",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "primeng/icons/sortalt",
	},
	36534: {
		getter: () => (Promise.all([__webpack_require__.e(7234), __webpack_require__.e(81208), __webpack_require__.e(97586), __webpack_require__.e(87670), __webpack_require__.e(29393), __webpack_require__.e(48471), __webpack_require__.e(60302), __webpack_require__.e(83255), __webpack_require__.e(29068), __webpack_require__.e(44569), __webpack_require__.e(61207), __webpack_require__.e(51463), __webpack_require__.e(57035), __webpack_require__.e(42863), __webpack_require__.e(25902)]).then(() => (() => (__webpack_require__(25902))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/portal-feature-shell",
	},
	61528: {
		getter: () => (Promise.all([__webpack_require__.e(97472), __webpack_require__.e(10655)]).then(() => (() => (__webpack_require__(10655))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations/browser",
	},
	7696: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(87670), __webpack_require__.e(46356), __webpack_require__.e(90714), __webpack_require__.e(78832), __webpack_require__.e(48471), __webpack_require__.e(51965), __webpack_require__.e(68687), __webpack_require__.e(72486), __webpack_require__.e(99181), __webpack_require__.e(26336), __webpack_require__.e(13135)]).then(() => (() => (__webpack_require__(13135))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/documentation-feature-sign-document",
	},
	2190: {
		getter: () => (Promise.all([__webpack_require__.e(87670), __webpack_require__.e(26336), __webpack_require__.e(72076), __webpack_require__.e(79582)]).then(() => (() => (__webpack_require__(25642))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/documentation-feature-pending-conditions",
	},
	12548: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(87670), __webpack_require__.e(46356), __webpack_require__.e(90714), __webpack_require__.e(71667), __webpack_require__.e(62336), __webpack_require__.e(26336), __webpack_require__.e(72076), __webpack_require__.e(57201)]).then(() => (() => (__webpack_require__(58238))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/documentation-feature-upload-file",
	},
	62616: {
		getter: () => (Promise.all([__webpack_require__.e(90714), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(93429))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/documentation-feature-processing-petition",
	},
	94320: {
		getter: () => (Promise.all([__webpack_require__.e(13063), __webpack_require__.e(46356), __webpack_require__.e(70287), __webpack_require__.e(77729)]).then(() => (() => (__webpack_require__(77729))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/payments-feature-main",
	},
	80258: {
		getter: () => (Promise.all([__webpack_require__.e(48894), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(52909))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/personal-data-feature-main",
	},
	50362: {
		getter: () => (Promise.all([__webpack_require__.e(46356), __webpack_require__.e(59658), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(86031))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/studies-feature-main",
	},
	27890: {
		getter: () => (Promise.all([__webpack_require__.e(46356), __webpack_require__.e(28431), __webpack_require__.e(99274), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(39294))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/modifications-feature-main",
	},
	14840: {
		getter: () => (Promise.all([__webpack_require__.e(71667), __webpack_require__.e(651), __webpack_require__.e(58045), __webpack_require__.e(69888), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(55588))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/discounts-feature-main",
	},
	89724: {
		getter: () => (Promise.all([__webpack_require__.e(46356), __webpack_require__.e(73344), __webpack_require__.e(36591), __webpack_require__.e(93906), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(6086))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/academic-variation-feature-main",
	},
	26864: {
		getter: () => (Promise.all([__webpack_require__.e(64869), __webpack_require__.e(72076)]).then(() => (() => (__webpack_require__(39233))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@unir/documentation-feature-main",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"651": [
		651
	],
	"1949": [
		1949
	],
	"2190": [
		2190
	],
	"2812": [
		2812
	],
	"3036": [
		11335,
		30079
	],
	"4456": [
		4456
	],
	"6921": [
		6921
	],
	"7234": [
		7234
	],
	"7696": [
		7696
	],
	"8186": [
		8186
	],
	"10982": [
		10982
	],
	"12530": [
		12530
	],
	"12548": [
		12548
	],
	"13063": [
		13063
	],
	"14309": [
		14309
	],
	"14733": [
		37114
	],
	"14840": [
		14840
	],
	"15176": [
		15176
	],
	"15728": [
		50440
	],
	"16026": [
		16026
	],
	"16280": [
		54452,
		62760,
		64362
	],
	"17592": [
		97940
	],
	"17928": [
		17928
	],
	"20252": [
		20252
	],
	"22314": [
		22314
	],
	"25211": [
		23618,
		8860
	],
	"25338": [
		25338
	],
	"25902": [
		49384
	],
	"26277": [
		26277
	],
	"26336": [
		26336
	],
	"26399": [
		26399
	],
	"26864": [
		26864
	],
	"26895": [
		1188
	],
	"27890": [
		27890
	],
	"28431": [
		28431
	],
	"29068": [
		29068
	],
	"29253": [
		29253
	],
	"29393": [
		29393
	],
	"31144": [
		61288
	],
	"31292": [
		31292
	],
	"32714": [
		32714
	],
	"33264": [
		34594,
		60277,
		68520,
		78632,
		85486,
		87421
	],
	"33358": [
		33358
	],
	"34615": [
		34615
	],
	"35088": [
		35088
	],
	"36534": [
		36534
	],
	"36591": [
		36591
	],
	"37580": [
		55458,
		77500
	],
	"37650": [
		37650
	],
	"40378": [
		40378
	],
	"40684": [
		40684
	],
	"41314": [
		7880,
		23524
	],
	"42863": [
		42863
	],
	"43157": [
		58444,
		78702,
		93844
	],
	"43324": [
		43324
	],
	"44569": [
		44569
	],
	"45340": [
		45340
	],
	"46356": [
		46356
	],
	"48471": [
		48471
	],
	"48894": [
		48894
	],
	"50362": [
		50362
	],
	"51463": [
		51463
	],
	"51965": [
		51965
	],
	"54730": [
		54730
	],
	"56551": [
		56551
	],
	"56607": [
		56607
	],
	"57035": [
		57035
	],
	"58045": [
		58045
	],
	"59658": [
		59658
	],
	"60302": [
		60302
	],
	"61207": [
		61207
	],
	"61528": [
		61528
	],
	"61759": [
		92552
	],
	"62336": [
		62336
	],
	"62616": [
		62616
	],
	"63478": [
		63478
	],
	"63786": [
		63786
	],
	"64266": [
		64266
	],
	"64869": [
		64869
	],
	"65475": [
		89056
	],
	"66664": [
		44283
	],
	"67819": [
		67819
	],
	"68687": [
		68687
	],
	"68895": [
		68895
	],
	"69888": [
		82221,
		97220
	],
	"70287": [
		70287
	],
	"71667": [
		71667
	],
	"72486": [
		72486
	],
	"73046": [
		73046
	],
	"73344": [
		73344
	],
	"76005": [
		76005
	],
	"76676": [
		16888,
		18186,
		31840,
		44680,
		54808,
		63628,
		67054,
		69274,
		79442
	],
	"77543": [
		77543
	],
	"77729": [
		16316,
		99235
	],
	"78057": [
		4442
	],
	"78832": [
		78832
	],
	"80258": [
		80258
	],
	"81208": [
		81208
	],
	"81642": [
		81642
	],
	"82090": [
		82090
	],
	"83255": [
		83255
	],
	"84368": [
		84368
	],
	"84760": [
		15488,
		27288,
		27946,
		28578,
		30836,
		38396,
		41678,
		45280,
		55046,
		56100,
		57880,
		61660,
		64730,
		66800,
		78520,
		80530,
		81958,
		84826,
		86718,
		91690
	],
	"85431": [
		48986,
		66664
	],
	"86116": [
		86116
	],
	"86395": [
		32743,
		89590,
		93447
	],
	"86525": [
		17978,
		23366
	],
	"87438": [
		87438
	],
	"87670": [
		87670
	],
	"88432": [
		88432
	],
	"89724": [
		89724
	],
	"90714": [
		90714
	],
	"92381": [
		92381
	],
	"93106": [
		93106
	],
	"93860": [
		93860
	],
	"93906": [
		5047,
		88304
	],
	"94320": [
		94320
	],
	"96371": [
		58162,
		72600
	],
	"97472": [
		97472
	],
	"97586": [
		97586
	],
	"97656": [
		97656
	],
	"98807": [
		98807
	],
	"99181": [
		99181
	],
	"99274": [
		99274
	],
	"99398": [
		99398
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}